// components/branches/config/appointment/NotificationSettings.jsx
import React from "react";

const NotificationSettings = ({ config, onChange, isEditMode }) => {
  const CHANNELS = ["SMS", "EMAIL", "WHATSAPP", "PUSH"];

  return (
    <div className="space-y-6">
      <h3 className="text-lg font-semibold">Notification Settings</h3>
      <p className="text-gray-600">
        Configure how customers and staff are notified about appointments
      </p>

      {/* Master Toggle */}
      <div className="bg-blue-50 rounded-lg p-6">
        <div className="flex items-start justify-between">
          <div>
            <h4 className="font-medium">Enable Notifications</h4>
            <p className="text-sm text-gray-600 mt-1">
              Send automated notifications for appointments
            </p>
          </div>
          {isEditMode ? (
            <label className="relative inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                checked={config.enabled || false}
                onChange={(e) =>
                  onChange({ ...config, enabled: e.target.checked })
                }
                className="sr-only peer"
              />
              <div className="w-11 h-6 bg-gray-200 rounded-full peer peer-checked:bg-blue-600 peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all"></div>
            </label>
          ) : (
            <span
              className={`px-3 py-1 rounded-full text-sm font-medium ${
                config.enabled
                  ? "bg-green-100 text-green-800"
                  : "bg-gray-100 text-gray-800"
              }`}
            >
              {config.enabled ? "Enabled" : "Disabled"}
            </span>
          )}
        </div>
      </div>

      {config.enabled && (
        <>
          {/* Booking Confirmation */}
          <div className="bg-gray-50 rounded-lg p-6 space-y-4">
            <h4 className="font-medium">Booking Confirmation</h4>
            <div className="space-y-3">
              {CHANNELS.map((channel) => (
                <div key={channel} className="flex items-center gap-3">
                  <input
                    type="checkbox"
                    id={`booking-${channel}`}
                    defaultChecked
                    disabled={!isEditMode}
                    className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                  />
                  <label htmlFor={`booking-${channel}`} className="text-sm">
                    Send via {channel}
                  </label>
                </div>
              ))}
            </div>
          </div>

          {/* Reminders */}
          <div className="bg-green-50 rounded-lg p-6 space-y-4">
            <h4 className="font-medium">Appointment Reminders</h4>
            <div className="space-y-3">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Send Reminder
                </label>
                {isEditMode ? (
                  <div className="flex items-center gap-2">
                    <input
                      type="number"
                      min="1"
                      max="48"
                      defaultValue={2}
                      className="w-20 px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                    />
                    <span className="text-sm text-gray-600">hours before</span>
                  </div>
                ) : (
                  <p>2 hours before</p>
                )}
              </div>
            </div>
          </div>

          {/* Admin Notifications */}
          <div className="bg-purple-50 rounded-lg p-6 space-y-4">
            <h4 className="font-medium">Admin Notifications</h4>
            <div className="space-y-3">
              <div className="flex items-center gap-3">
                <input
                  type="checkbox"
                  id="admin-new"
                  defaultChecked
                  disabled={!isEditMode}
                  className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                />
                <label htmlFor="admin-new" className="text-sm">
                  Notify on new appointment
                </label>
              </div>
              <div className="flex items-center gap-3">
                <input
                  type="checkbox"
                  id="admin-cancel"
                  defaultChecked
                  disabled={!isEditMode}
                  className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                />
                <label htmlFor="admin-cancel" className="text-sm">
                  Notify on cancellation
                </label>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default NotificationSettings;
